import get from 'lodash/get';
import identityConfig from '../../../../config/identity';
import { addQuotes } from '../../../../utils/string_util';

export default function krux(context) {
  const { postData, type } = context;
  const siteConfig = identityConfig;
  if (siteConfig === undefined) {
    return '';
  }
  const kruxConfig = get(siteConfig, 'krux');
  const keywords = get(siteConfig, 'keywords') || [];
  const siteName = get(siteConfig, 'siteName') || '';
  const KruxID = get(kruxConfig, 'id');
  let topicList = [];
  let category = '';
  let authorName = '';
  let articleId = null;
  let readTime = '';
  let contentType = type;

  if (type === 'post') {
    topicList = get(postData, 'tags');
    category = get(postData, 'categories[0].slug');
    authorName = get(postData, 'author.name');
    articleId = get(postData, 'id');
    readTime = get(postData, 'readTime');
    contentType = 'article';
    if (get(postData, 'posterSlideshow.length')) {
      contentType = 'slideshow';
    } else if (
      get(postData, 'hasVideoPoster') === true ||
      get(postData, 'posterVideo.feedId')
    ) {
      contentType = 'video';
    }
  }

  // On topic pages category is being passed in as the third param
  let tags = '';

  if (topicList) {
    topicList.forEach((tag, index) => {
      if (index !== get(topicList, 'length') - 1) {
        tags += `"${tag.name}",`;
      } else {
        tags += `"${tag.name}"`;
      }
    });
  }

  const KruxPreScript = `<script class="kxct" data-id="${KruxID}" data-timing="async" data-version="1.9" type="text/javascript"> window.Krux||((Krux=function(){Krux.q.push(arguments)}).q=[]); (function(){ var k=document.createElement("script");k.type="text/javascript";k.async=true; var m,src=(m=location.href.match(/\\bkxsrc=([^&]+)/))&&decodeURIComponent(m[1]); k.src = /^https?:\\/\\/([a-z0-9_\\-\\.]+\\.)?krxd\\.net(:\\d{1,5})?\\//i.test(src) ? src : src === "disable" ? "" : (location.protocol==="https:"?"https:":"http:")+"//cdn.krxd.net/controltag?confid=${KruxID}" ; var s=document.getElementsByTagName("script")[0];s.parentNode.insertBefore(k,s); }()); </script>`;

  return `
  ${KruxPreScript}
  <script>
      FC_Krux_FPA = {
          author: null,
          channels: null,
          subChannels: null,
          contentType: null,
          keywords: null,
          socialTags: null,
          siteName: null,
          referrerUrl: null,
          url: location.origin + location.pathname,
          querystring: null
      };
      FC_Krux_FPA['Read Length'] = "${readTime}";
      FC_Krux_FPA['Article ID'] = ${articleId};
      FC_Krux_FPA['Subchannel'] = ${
        category ? addQuotes(category.toString()) : null
      };
      FC_Krux_FPA['Channel'] = ${
        category ? addQuotes(category.toString()) : null
      };

      if(location.search !== '') {
          FC_Krux_FPA.querystring = location.search;
      }

      if(document.referrer) {
          FC_Krux_FPA.referrerUrl = document.referrer;
      }

      FC_Krux_FPA.channels = "${keywords}".split(',');
      FC_Krux_FPA.siteName = ${
        siteName ? addQuotes(siteName.toString()) : null
      };

      FC_Krux_FPA.author = ${
        authorName ? addQuotes(authorName.toString()) : null
      };
      FC_Krux_FPA.subChannels = ${
        category ? addQuotes(category.toString()) : null
      };
      FC_Krux_FPA.keywords = [${tags}];
      FC_Krux_FPA.socialTags = [${tags}];
      FC_Krux_FPA.contentType = ${
        contentType ? addQuotes(contentType.toString()) : null
      };

      window.FC_Krux_FPA = FC_Krux_FPA;
  </script>
  <script> window.Krux||((Krux=function(){Krux.q.push(arguments);}).q=[]); (function(){ function retrieve(n){ var m, k='kxmansueto_'+n; if(window.localStorage){ return window.localStorage[k] || ""; }else if(navigator.cookieEnabled){ m = document.cookie.match(k+'=([^;]*)'); return (m && unescape(m[1])) || ""; }else{ return ''; } } Krux.user = retrieve('user');})();
  </script>`;
}
